<div
  class="conclusion-wrapper"
  [formGroup]="conclusionForm"
  [class.mode-modal]="isModal"
>
  <header class="conclusion-header">
    <span class="view-label">{{
      "conclusionPage.conclusion" | translate
    }}</span>

    <div class="header-actions">
      <button
        class="glow-save-btn"
        *ngIf="!isReadOnly && canSaveConclusion"
        [disabled]="conclusionForm.invalid"
        (click)="saveConclusion()"
      >
        <span class="btn-text">{{
          "conclusionPage.saveConclusion" | translate
        }}</span>
      </button>

      <button
        class="glow-save-btn"
        *ngIf="canCompleteConclusion && isReadOnly"
        (click)="completeConclusion()"
      >
        <span class="btn-text">{{
          "conclusionPage.completeConclusion" | translate
        }}</span>
      </button>

      <button class="glow-save-btn" *ngIf="isModal" (click)="close.emit()">
        <span class="btn-text">{{ "close" | translate }}</span>
      </button>
    </div>
  </header>

  <div class="main-grid">
    <section class="glass-card full-width-card">
      <div class="card-section section-procedures">
        <div class="card-header">
          <h3>{{ "conclusionPage.appliedProcedures" | translate }}</h3>
          <button
            class="minimal-add-btn"
            [disabled]="isReadOnly"
            (click)="addProcedure()"
            type="button"
            *ngIf="!isReadOnly"
          >
            {{ "conclusionPage.addProcedure" | translate }}
          </button>
        </div>

        <div class="procedure-list" formArrayName="procedures" #procedureList>
          <div
            class="procedure-item"
            *ngFor="let proc of procedures.controls; let i = index"
          >
            <div class="input-wrapper">
              <input
                [formControlName]="i"
                class="modern-input"
                [placeholder]="
                  'conclusionPage.enterProcedureDetails' | translate
                "
              />
              <span class="input-focus-bg"></span>
            </div>

            <button
              type="button"
              class="delete-btn"
              (click)="removeProcedure(i)"
              *ngIf="procedures.length > 1 && !isReadOnly"
            >
              <i class="trash-icon">✕</i>
            </button>
          </div>
        </div>
      </div>

      <div class="card-section section-treatments">
        <div class="card-header">
          <h3>{{ "conclusionPage.treatmentDetails" | translate }}</h3>
        </div>

        <!-- Doctor View: Show treatments with checkboxes and details -->
        <div
          class="treatment-grid"
          formGroupName="treatments"
          *ngIf="!canCompleteConclusion || !isReadOnly"
        >
          <ng-container *ngFor="let key of treatmentKeys">
            <div
              class="modern-treatment-item"
              [formGroupName]="key"
              *ngIf="
                !isReadOnly ||
                (treatmentSelected(key) &&
                  treatmentsGroup.get(key).get('details')?.value)
              "
            >
              <label class="custom-checkbox">
                <input type="checkbox" formControlName="selected" />
                <span class="checkmark"></span>
                <span class="label-text"
                  >{{ key | titlecase }}
                  {{ "conclusionPage.protocol" | translate }}</span
                >
              </label>

              <div
                class="expandable-textarea"
                [class.expanded]="treatmentSelected(key)"
              >
                <textarea
                  formControlName="details"
                  [placeholder]="
                    'conclusionPage.notesForKey' | translate: { key: key }
                  "
                ></textarea>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Nurse View: Checklist with Read-Only Doctor Instructions -->
        <div
          class="treatment-grid"
          formGroupName="nurseTreatments"
          *ngIf="canCompleteConclusion && isReadOnly"
        >
          <ng-container *ngFor="let key of treatmentKeys">
            <div
              class="modern-treatment-item nurse-treatment-item simple-view"
              [formGroupName]="key"
              *ngIf="hasDoctorTreatment(key)"
            >
              <div class="treatment-header d-flex align-items-center w-100">
                <label class="custom-checkbox m-0">
                  <input type="checkbox" formControlName="completed" />
                  <span class="checkmark"></span>
                </label>

                <div class="ms-3 flex-grow-1 mt-1">
                  <span class="fw-bold text-uppercase text-white me-2">
                    {{ key | titlecase }}
                    {{ "conclusionPage.protocol" | translate }} :
                  </span>
                  <span class="text-white">
                    {{ getDoctorTreatmentDetails(key) }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="card-section section-followup">
        <div class="card-header">
          <h3>{{ "conclusionPage.followUpPlan" | translate }}</h3>
        </div>
        <div class="select-container">
          <app-select
            formControlName="followUp"
            [items]="followUpOptions"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            appendTo="body"
            [placeholder]="'conclusionPage.selectFollowUpPlan' | translate"
          >
          </app-select>
          <div class="select-arrow"></div>
        </div>
      </div>

      <div
        class="card-section section-nurse-note"
        *ngIf="canCompleteConclusion && isReadOnly"
      >
        <div class="card-header">
          <h3>{{ "conclusionPage.nurseNote" | translate }}</h3>
        </div>
        <div class="textarea-container">
          <textarea
            formControlName="nurseNote"
            class="modern-textarea"
            maxlength="1000"
            [placeholder]="'conclusionPage.enterNurseNote' | translate"
          ></textarea>
        </div>
      </div>
    </section>
  </div>
</div>
